// extracted by mini-css-extract-plugin
export default {"paperModal":"paperModal_paperModal__OcQ2r"};